import React from "react";
import { Image as KonvaImage } from "react-konva"
//import { useAppSelector } from "../../../../store/hooks"
import { Transform } from "../../../../geometry/transformation"
//import { hitStrokeCorrection } from "../../util/strokeCorrection"
//import { useMemo } from "react"
//import { RootState } from "../../../../store/store"
import useImage from 'use-image';

const BaseImage = (({ setRef, shapeProps, onClick, interaction }: BaseShapeProps<SymbolShape>) => {
    //const lineTypes = useAppSelector((state: RootState) => state.tool.lineTypes)
    //const scale = useAppSelector((state: RootState) => state.interface.viewport.scale)
    // const lineRef = useRef<Konva.Line>(null);
    // const dispatch = useAppDispatch();
    const trafo = new Transform(shapeProps.transformation);

    const trafoedPoints = shapeProps.points.map(coordiante => {
        const c = trafo.point2d(coordiante);
        return { ...coordiante, x: c.x, y: c.y }
    });
    //const correctedHitStrokeWidth = useMemo(() => hitStrokeCorrection(shapeProps.hitStrokeWidth, shapeProps.strokeWidth, scale), [shapeProps, scale]);
    // useEffect(() => {
    //     console.log(lineRef.current?.id());

    //     if (setRef) setRef(lineRef)
    //     const size = lineRef.current?.size();
    //     const payload = size ? { size: size, id: shapeProps.id } : undefined;
    //     // dispatch(modelUpdateBoundingbox(payload))
    // }, [lineRef, setRef])
    // console.log("cucc");


    const newProps = /* useMemo(() => {


        return  */{
        ...shapeProps,
        id: `${shapeProps.id}`,
        points: trafoedPoints.flatMap(p => [p.x, -p.y]),
        draggable: shapeProps.draggable ? shapeProps.draggable : true,
        // closed:
        //     shapeProps.points.length > 5 &&
        //     shapeProps.points[0] === shapeProps.points[shapeProps.points.length - 2] &&
        //     shapeProps.points[1] === shapeProps.points[shapeProps.points.length - 1],
    }
    /*} , [shapeProps, correctedHitStrokeWidth, lineTypes, trafoedPoints]) */


    // useEffect(() => {
    //     console.log("box", lineRef.current?.width(), lineRef.current?.height());
    // })
    // const Line = useMemo(() => {
    //     console.log("useMemoNewProps", newProps.points);
    //     return (
    //         <><KonvaLine
    //             ref={lineRef}
    //             key={shapeProps.id}
    //             dragBoundFunc={function (this, pos) {
    //                 return this._lastPos || this.absolutePosition()
    //             }}
    //             onDragStart={interaction?.handleDragStart}
    //             onDragMove={interaction?.handleDragMove}
    //             onDragEnd={interaction?.handleDragEnd}
    //             onClick={onClick}
    //             {...newProps} />
    //             {/* <Circle x={newProps.transformation[3][0]} y={-newProps.transformation[3][1]} radius={25} fill="green" />
    //             <Circle x={newProps.transformation[3][0]+ newProps.width} y={-newProps.transformation[3][1]+newProps.height} radius={25} fill="green" /> */}
    //         </>
    //     )
    // }, [shapeProps.id, interaction, onClick, newProps.points])

    const URLImage = ({ src, height, width, ...rest }: any) => {
        const [image] = useImage(src, 'anonymous');
        height = (image && image?.height > 0) ? image?.height : image?.naturalHeight;
        width = (image && image?.width > 0) ? image?.width : image?.naturalWidth;
        return <KonvaImage image={image} height={height}  width={width} {...rest} />;
    };

    return (
        <>
        {/* {!shapeProps.image && <URLImage
            ref={setRef}
            key={shapeProps.id}
            // dragBoundFunc={function (this, pos) {
            //     return this._lastPos || this.absolutePosition();
            // }}
            onDragStart={interaction?.handleDragStart}
            onDragMove={interaction?.handleDragMove}
            onDragEnd={interaction?.handleDragEnd}
            onClick={onClick}
            {...newProps}
            x={newProps.points[0]}
            y={newProps.points[1]}
            src={"https://konvajs.org/assets/yoda.jpg"}
        />} */}
        {shapeProps.image &&
            <URLImage
                src={shapeProps.image}
                x={newProps.points[0]}
                y={newProps.points[1]}
                key={shapeProps.id}
                // dragBoundFunc={function (this, pos) {
                //     return this._lastPos || this.absolutePosition();
                // }}
                onDragStart={interaction?.handleDragStart}
                onDragMove={interaction?.handleDragMove}
                onDragEnd={interaction?.handleDragEnd}
                onClick={onClick}
                //{...newProps}

            />
        }
        </>
        // Line
    )
})
const createImageBase = (shapeProps: GeometricShape) => {
    return <BaseImage shapeProps={shapeProps as SymbolShape} ></BaseImage>
}

export { createImageBase }
export default BaseImage;